import 'client-only';

import { atom, useAtom } from 'jotai';

import { useProductSelectionAndCheckoutCommonData } from './useProductSelectionAndCheckoutCommonData';

const taxAtom = atom<number | undefined>(undefined);

export const useTax = () => {
  const [currentTax, setTax] = useAtom(taxAtom);
  const { initialTax } = useProductSelectionAndCheckoutCommonData();

  const tax = currentTax ?? initialTax;

  return {
    tax,
    setTax,
  };
};
